import React from 'react';
import styled from 'styled-components';
import { IconHelp } from 'cdk-radial';
import { useTranslation } from 'react-i18next';
import { CustomScrollbarWrapper } from 'cdk-radial';
import DynamicHelp from './DynamicHelp';
 import * as Styles from '../core/styles';
 
export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100vh - 80px);
  overflow-x: hidden;
`;
const FeaturedHelpLink = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 24px;
  svg {
    width: 40px;
    height: 40px;
  }
`;
const HelpSheetContent = styled.div`
  font-family:  'Roboto','Montserrat', sans-serif;
  font-size: 1rem;
  // TODO: shouldn't need to do this but don't know where line height is inheriting from
  line-height: normal;
`;

const Help = React.memo(() => {

  const { t } = useTranslation();

  return (

    <HelpSheetContent>
      <StyledCustomScrollbarWrapper>
        <Styles.SideSheetBody>
          <FeaturedHelpLink>
            <IconHelp />
            <h4>{t('help.topHelpTopics')}</h4>
          </FeaturedHelpLink>
          <div style={{ margin: '-20px' }}>
            <DynamicHelp />
          </div>
          </Styles.SideSheetBody>
      </StyledCustomScrollbarWrapper>
    </HelpSheetContent>
  );
});
export default Help;